import { useSortable } from '@dnd-kit/sortable'
import type { Transform } from '@dnd-kit/utilities'
import { CSS } from '@dnd-kit/utilities'
import type { ReactNode } from 'react'

export type SortableItemProps = {
  id: string
  render: () => ReactNode
  transformStyle?: Partial<Transform>
}

export function SortableItem(props: SortableItemProps) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id: props.id })

  const style = {
    transform: transform
      ? props.transformStyle
        ? CSS.Transform.toString({ ...transform, ...props.transformStyle })
        : CSS.Transform.toString({ ...transform })
      : undefined,
    transition,
    zIndex: isDragging ? 1 : undefined,
    opacity: 1,
  }

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      {props.render()}
    </div>
  )
}
